//QrLocationForm.js
import React, { useState, useEffect, useRef, useCallback } from "react";
import { LoadScript, Autocomplete, GoogleMap } from "@react-google-maps/api";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { useJsApiLoader } from "@react-google-maps/api";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Marker, InfoWindow } from "@react-google-maps/api";
import QrScanner from "../components/QrScanner";

const QrLocationForm = () => {
  const [autocomplete, setAutocomplete] = useState(null);
  const [address, setAddress] = useState("");
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [note, setNote] = useState("");
  const [qrCodeId, setQrCodeId] = useState("");
  const [qrOptions, setQrOptions] = useState([]);
  const [locations, setLocations] = useState([]);
  const [availableQRCodes, setAvailableQRCodes] = useState([]);
  const [selectedCodeId, setSelectedCodeId] = useState("");
  const [selectedQrLocation, setSelectedQrLocation] = useState(null);
  const [user, setUser] = useState(null);
  const qrClustererRef = useRef(null);
  const mapRef = useRef(null);
const [roles, setRoles] = useState([]);
const [loading, setLoading] = useState(true);
const [isAdmin, setIsAdmin] = useState(false);
const navigate = useNavigate();
const [editMode, setEditMode] = useState(false);
const [editId, setEditId] = useState(null);
const [activeMarker, setActiveMarker] = useState(null);
const [showScanner, setShowScanner] = useState(false);
const [interactionMap, setInteractionMap] = useState({});
// 👇 NOVO:
const [locating, setLocating] = useState(false);
const geocoderRef = useRef(null);
const myMarkerRef = useRef(null);



useEffect(() => {
  const auth = getAuth();
  const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
    if (currentUser) {
      setUser(currentUser);
      const token = await currentUser.getIdToken();

      const res = await axios.get("https://modularobjects.com/checkout/api/user/me", {
        headers: { Authorization: `Bearer ${token}` },
      });

      const roles = res.data.roles || [];
      setRoles(roles);
      setIsAdmin(roles.includes("admin"));
    } else {
      setUser(null);
    }

    setLoading(false); // ✅ obavezno
  });

  return () => unsubscribe();
}, []);


const handleEdit = (location) => {
  setEditMode(true);
  setEditId(location.id || location.location_id);
  setSelectedCodeId(location.qr_code_id);
  setAddress(location.address);
  setLatitude(location.latitude);
  setLongitude(location.longitude);
  setNote(location.note || "");
  window.scrollTo({ top: 0, behavior: "smooth" });
};


  const { isLoaded } = useJsApiLoader({
  googleMapsApiKey: "AIzaSyBDgiqSTEJ1WJ-2IaESi4sh5_uGhjOxm7Y",
  libraries: ["places"],
});

useEffect(() => {
  if (!loading && (!user || !isAdmin)) {
    navigate("/login"); // ili neka druga stranica
  }
}, [user, isAdmin, loading, navigate]);

  useEffect(() => {
    const fetchAvailable = async () => {
      const res = await fetch("https://www.modularobjects.com/marketing/api/qr-location/available");
      const data = await res.json();
      setAvailableQRCodes(data);
    };
    fetchAvailable();
  }, []);

  useEffect(() => {
  if (isLoaded && window.google && window.google.maps) {
    geocoderRef.current = new window.google.maps.Geocoder();
  }
}, [isLoaded]);


  useEffect(() => {
    setQrCodeId(selectedCodeId);
  }, [selectedCodeId]);

  useEffect(() => {
    fetch("https://www.modularobjects.com/marketing/api/qrcodes/list")
      .then((res) => res.json())
      .then((data) => setQrOptions(data))
      .catch((err) => console.error("Error loading QR codes:", err));
  }, []);

  useEffect(() => {
    fetch("https://www.modularobjects.com/marketing/api/qr-location")
      .then((res) => res.json())
      .then((data) => setLocations(data))
      .catch((err) => console.error("Error loading locations:", err));
  }, []);

  useEffect(() => {
  axios.get("https://www.modularobjects.com/marketing/api/qr-location/interactions")
    .then((res) => {
      const map = {};
      res.data.forEach(item => {
        map[item.code] = item.interaction_count;
      });
      setInteractionMap(map);
    })
    .catch((err) => console.error("Greška pri učitavanju interakcija:", err));
}, []);


  const onPlaceChanged = () => {
    if (autocomplete) {
      const place = autocomplete.getPlace();
      if (!place.formatted_address || !place.geometry) {
        alert("Please select a valid address from the list.");
        return;
      }
      setAddress(place.formatted_address);
      const location = place.geometry.location;
      setLatitude(location.lat());
      setLongitude(location.lng());
    }
  };

  // 👇 NOVO:
const reverseGeocode = async (lat, lng) => {
  return new Promise((resolve, reject) => {
    if (!geocoderRef.current) return reject(new Error("Geocoder not ready"));
    geocoderRef.current.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === "OK" && results && results[0]) {
        const place = results[0];
        const components = place.address_components;

        let street = "";
        let streetNumber = "";

        components.forEach(c => {
          if (c.types.includes("route")) {
            street = c.long_name;       // npr. "Bulevar kralja Aleksandra"
          }
          if (c.types.includes("street_number")) {
            streetNumber = c.long_name; // npr. "123"
          }
        });

        resolve({
          formatted: place.formatted_address,  // cela adresa
          street,
          streetNumber,
          city: (components.find(c => c.types.includes("locality")) || {}).long_name || "",
          country: (components.find(c => c.types.includes("country")) || {}).long_name || ""
        });
      } else {
        reject(new Error(`Geocode failed: ${status}`));
      }
    });
  });
};


// 👇 NOVO:
const useMyLocation = () => {
  if (!("geolocation" in navigator)) {
    alert("Geolokacija nije podržana u ovom browseru.");
    return;
  }

  setLocating(true);

  navigator.geolocation.getCurrentPosition(
    async (pos) => {
      try {
        const lat = pos.coords.latitude;
        const lng = pos.coords.longitude;

        setLatitude(lat);
        setLongitude(lng);

        // Reverse geocode -> adresa u inputu
        try {
  const addrData = await reverseGeocode(lat, lng);
  setAddress(addrData.formatted);   // i dalje puniš input
  console.log("Ulica:", addrData.street);
  console.log("Broj:", addrData.streetNumber);
} catch (e) {
  console.error(e);
}


        // Map: centriraj i zumiraj
        if (mapRef.current) {
          mapRef.current.setCenter({ lat, lng });
          mapRef.current.setZoom(16);

          // Postavi / pomeri privremeni marker za "moju lokaciju"
          if (myMarkerRef.current) {
            myMarkerRef.current.setPosition({ lat, lng });
          } else {
            myMarkerRef.current = new window.google.maps.Marker({
              position: { lat, lng },
              map: mapRef.current,
              icon: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
              title: "Your current location",
            });
          }
        }

        // (opciono) suzi Autocomplete na okolinu trenutne lokacije
        if (autocomplete && window.google?.maps?.Circle) {
          const circle = new window.google.maps.Circle({
            center: { lat, lng },
            radius: 5000, // 5 km
          });
          autocomplete.setBounds(circle.getBounds());
          autocomplete.setOptions({ strictBounds: false });
        }
      } finally {
        setLocating(false);
      }
    },
    (err) => {
      setLocating(false);
      let msg = "Ne mogu da dohvatim lokaciju.";
      if (err.code === err.PERMISSION_DENIED) msg = "Pristup lokaciji je odbijen.";
      if (err.code === err.POSITION_UNAVAILABLE) msg = "Lokacija nije dostupna.";
      if (err.code === err.TIMEOUT) msg = "Isteklo vreme za dobijanje lokacije.";
      alert(msg);
    },
    {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 30000,
    }
  );
};


  const updateQrMarkers = useCallback(() => {
    if (!mapRef.current || !locations?.length) return;

    const validLocations = locations.filter(loc =>
      loc.latitude && loc.longitude &&
      !isNaN(parseFloat(loc.latitude)) &&
      !isNaN(parseFloat(loc.longitude))
    );

    if (qrClustererRef.current) {
      qrClustererRef.current.clearMarkers();
    }

    const markers = validLocations.map((loc) => {
      const marker = new window.google.maps.Marker({
        position: {
          lat: parseFloat(loc.latitude),
          lng: parseFloat(loc.longitude)
        },
        icon: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
      });

      marker.addListener("click", () => {
        setSelectedQrLocation(loc);
        mapRef.current.setZoom(15);
        mapRef.current.panTo(marker.getPosition());
      });

      return marker;
    });

    if (markers.length > 0) {
      if (!qrClustererRef.current) {
        qrClustererRef.current = new MarkerClusterer({
          map: mapRef.current,
          markers,
          renderer: {
            render: ({ count, position }) => {
              const size = Math.min(10 + Math.sqrt(count) * 5, 30);
              return new window.google.maps.Marker({
                position,
                icon: {
                  path: window.google.maps.SymbolPath.CIRCLE,
                  fillColor: "#e63946",
                  fillOpacity: 0.8,
                  strokeColor: "#9d0208",
                  strokeWeight: 2,
                  scale: size,
                },
                label: {
                  text: String(count),
                  color: "#ffffff",
                  fontSize: "12px",
                  fontWeight: "bold",
                },
              });
            },
          },
        });

        qrClustererRef.current.addListener("clusterclick", (cluster) => {
          const bounds = new window.google.maps.LatLngBounds();
          cluster.getMarkers().forEach(marker => bounds.extend(marker.getPosition()));
          mapRef.current.fitBounds(bounds);
          if (mapRef.current.getZoom() > 15) {
            mapRef.current.setZoom(mapRef.current.getZoom() + 1);
          }
        });
      } else {
        qrClustererRef.current.addMarkers(markers);
      }

      const bounds = new window.google.maps.LatLngBounds();
      markers.forEach(marker => bounds.extend(marker.getPosition()));
      mapRef.current.fitBounds(bounds, { padding: 50 });
    }
  }, [locations]);

  useEffect(() => {
    if (isLoaded && mapRef.current && locations.length > 0) {
      updateQrMarkers();
    }
  }, [isLoaded, locations, updateQrMarkers]);

  useEffect(() => {
    return () => {
      if (qrClustererRef.current) {
        qrClustererRef.current.clearMarkers();
      }
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!address || latitude === null || longitude === null || !qrCodeId) {
      alert("Please fill all required fields.");
      return;
    }

    try {
      const response = await fetch("https://www.modularobjects.com/marketing/api/qr-location", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          qr_code_id: qrCodeId,
          address,
          latitude,
          longitude,
          note,
        }),
      });

      const result = await response.json();
      if (result.success) {
        alert("Location saved successfully.");

        const selectedQr = qrOptions.find((x) => x.id == qrCodeId);

        setLocations([
          ...locations,
          {
            id: Date.now(),
            qr_code_id: qrCodeId,
            address,
            latitude,
            longitude,
            note,
            code: selectedQr?.code || "",
            campaign_name: selectedQr?.campaign_name || "",
            landing_url: selectedQr?.landing_url || "#",
          },
        ]);

        setAddress("");
        setLatitude(null);
        setLongitude(null);
        setNote("");
        setQrCodeId("");
      } else {
        alert("Error: " + result.message);
      }
    } catch (error) {
      console.error("Submit error:", error);
      alert("Submission error.");
    }
  };

  const onMapLoad = useCallback((map) => {
    mapRef.current = map;
    updateQrMarkers();
  }, [updateQrMarkers]);

// helper: bezbedno poređenje
const norm = (s) => (s || "").trim().toLowerCase();

// 🔎 Da li je kod "u sistemu" (poznat)
const isCodeInSystem = async (code) => {
  if (!code) return false;

  // 1) dostupni/slobodni kodovi (select lista)
  const inAvailable = availableQRCodes.some(c => norm(c.code) === norm(code));
  if (inAvailable) return true;

  // 2) svi QR kodovi (ako već učitavaš listu svih kodova)
  const inAll = qrOptions.some(c => norm(c.code) === norm(code));
  if (inAll) return true;

  // 3) (opciono) ping API za sigurnost – ako želiš
  // try {
  //   const res = await fetch(`https://www.modularobjects.com/marketing/api/qrcodes/exists?code=${encodeURIComponent(code)}`);
  //   const data = await res.json();
  //   return !!data?.exists;
  // } catch { /* ignore */ }

  return false;
};


 return isLoaded ? (
  <>
    <form onSubmit={handleSubmit} style={{
  maxWidth: "600px",
  margin: "0 auto",
  padding: "20px",
  border: "1px solid #ccc",
  borderRadius: "10px",
  backgroundColor: "#f9f9f9",
  display: "flex",
  flexDirection: "column",
  gap: "15px",
}}>
  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
  <button
    type="button"
    onClick={() => setShowScanner(true)}
    style={{
      backgroundColor: "#28a745",
      color: "#fff",
      padding: "10px",
      border: "none",
      borderRadius: "5px",
      marginBottom: "10px",
      maxWidth: "200px",
      width: "100%"
    }}
  >
    📷 Skeniraj QR kod
  </button>
    <label style={{ fontWeight: "bold", marginBottom: "5px" }}>QR code:</label>
    <select
      value={selectedCodeId}
      onChange={(e) => setSelectedCodeId(e.target.value)}
      style={{
        padding: "10px",
        borderRadius: "5px",
        border: "1px solid #ccc",
        fontSize: "16px"
      }}
    >
      <option value="">-- Select QR code --</option>
      {availableQRCodes.map((code) => (
        <option key={code.id} value={code.id}>
          {code.code} ({code.campaign_name})
        </option>
      ))}
    </select>
  </div>

  <div style={{ display: "flex", flexDirection: "column" }}>
  <label style={{ fontWeight: "bold", marginBottom: "8px", display: "flex", alignItems: "center", gap: "8px" }}>
    Address
    <button
      type="button"
      onClick={useMyLocation}
      disabled={locating}
      style={{
        marginLeft: "auto",
        backgroundColor: locating ? "#6c757d" : "#17a2b8",
        color: "#fff",
        padding: "6px 10px",
        border: "none",
        borderRadius: "5px",
        cursor: locating ? "not-allowed" : "pointer",
        fontSize: "14px"
      }}
      title="Use current location"
    >
      {locating ? "Locating..." : "📍 Use my location"}
    </button>
  </label>

  <Autocomplete onLoad={setAutocomplete} onPlaceChanged={onPlaceChanged}>
    <input
      type="text"
      placeholder="Enter address"
      value={address}
      required
      onChange={(e) => setAddress(e.target.value)}
      style={{
        padding: "10px",
        borderRadius: "5px",
        border: "1px solid #ccc",
        fontSize: "16px",
        width: "100%"
      }}
    />
  </Autocomplete>
</div>


  <div style={{ display: "flex", flexDirection: "column" }}>
    <label style={{ fontWeight: "bold", marginBottom: "5px" }}>Note:</label>
    <textarea
      value={note}
      onChange={(e) => setNote(e.target.value)}
      rows={3}
      style={{
        padding: "10px",
        borderRadius: "5px",
        border: "1px solid #ccc",
        fontSize: "16px",
        resize: "vertical"
      }}
    />
  </div>

  <button type="submit" style={{
    padding: "12px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "5px",
    fontSize: "16px",
    cursor: "pointer"
  }}>
    Save Location
  </button>
</form>
{showScanner && (
  <QrScanner
    isCodeInSystem={isCodeInSystem}
    closeOnSuccess={false}
    allowContinuousScan={false}
    onScanSuccess={(scannedCode) => {
      const matchedAvailable = availableQRCodes.find(
        (c) => norm(c.code) === norm(scannedCode)
      );

      if (matchedAvailable) {
        setSelectedCodeId(matchedAvailable.id);
        alert(`✅ QR kod prepoznat: ${scannedCode}`);
        setShowScanner(false);
        return;
      }

      const matchInLocations = locations.find(
        (loc) => norm(loc.code) === norm(scannedCode)
      );

      if (matchInLocations) {
        const confirmEdit = window.confirm(
          `⚠️ QR kod "${scannedCode}" je već dodeljen. Želite li da uredite postojeće podatke?`
        );

        if (confirmEdit) {
          handleEdit(matchInLocations);
        }

        setShowScanner(false);
        return;
      }

      const matchInAll = qrOptions.find(
        (q) => norm(q.code) === norm(scannedCode)
      );

      if (matchInAll) {
        alert(
          `ℹ️ Kod postoji u katalogu, ali nije među slobodnim i nema lokaciju u ovoj listi: ${scannedCode}`
        );
      } else {
        alert(`❌ QR kod "${scannedCode}" nije pronađen.`);
      }

      setShowScanner(false);
    }}
    onClose={() => setShowScanner(false)}
  />
)}



      <h3 style={{ textAlign: "center", marginTop: "40px" }}>🗺️ Map Locations</h3>
    <div style={{ width: "100%", height: "400px", marginBottom: "30px" }}>
      <GoogleMap
  mapContainerStyle={{ width: "100%", height: "100%" }}
  center={
    locations.length > 0
      ? { lat: parseFloat(locations[0].latitude), lng: parseFloat(locations[0].longitude) }
      : { lat: 44.7866, lng: 20.4489 }
  }
  zoom={locations.length > 0 ? 8 : 5}
  onLoad={onMapLoad}
>
  {/* Prikaz InfoWindow ako je selektovana lokacija */}
  {selectedQrLocation && (
    <InfoWindow
  position={{
    lat: parseFloat(selectedQrLocation.latitude),
    lng: parseFloat(selectedQrLocation.longitude),
  }}
  onCloseClick={() => setSelectedQrLocation(null)}
>
  <div style={{
    maxWidth: "280px", // šire
    minWidth: "200px",
    fontFamily: "Arial, sans-serif",
    padding: "12px",
    lineHeight: 1.5, // veći razmak između linija
    color: "#333",
    wordWrap: "break-word",
    overflowY: "auto",
    maxHeight: "300px", // povećana visina pre scrolla
  }}>
    <h4 style={{
      margin: "0 0 10px",
      fontSize: "17px",
      fontWeight: "bold",
      color: "#007bff"
    }}>
      QR Code: <span style={{ wordBreak: "break-word" }}>{selectedQrLocation.code}</span>
    </h4>

    <div style={{ marginBottom: "8px" }}>
      <strong>📅 Campaign:</strong><br />
      {selectedQrLocation.campaign_name}
    </div>

    <div style={{ marginBottom: "8px" }}>
      <strong>📍 Address:</strong><br />
      {selectedQrLocation.address}
    </div>

    

    <div style={{ marginBottom: "8px" }}>
      <strong>📝 Note:</strong><br />
      {selectedQrLocation.note}
    </div>

    <div style={{ marginBottom: "12px" }}>
      <a href={selectedQrLocation.landing_url} target="_blank" rel="noopener noreferrer" style={{
        color: "#007bff",
        textDecoration: "underline",
        fontWeight: "bold"
      }}>
        🔗 Open Landing Page
      </a>
    </div>

    <button
      onClick={() => {
        handleEdit(selectedQrLocation);
        setSelectedQrLocation(null);
      }}
      style={{
        backgroundColor: "#ffc107",
        color: "#000",
        border: "none",
        padding: "7px 12px",
        borderRadius: "5px",
        cursor: "pointer",
        fontSize: "14px",
        display: "flex",
        alignItems: "center",
        gap: "6px"
      }}
    >
      ✏️ Edit
    </button>
  </div>
</InfoWindow>


  )}
</GoogleMap>
    </div>

      <h3 style={{ marginTop: "40px", textAlign: "center" }}>📍 Locations</h3>
      <div style={{ overflowX: "auto", maxWidth: "100%" }}>
  <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "800px" }}>
    <thead>
      <tr>
        <th style={{ border: "1px solid #ccc", padding: "6px" }}>QR Code</th>
        <th style={{ border: "1px solid #ccc", padding: "6px" }}>Interactions</th>
        <th style={{ border: "1px solid #ccc", padding: "6px" }}>Campaign</th>
        <th style={{ border: "1px solid #ccc", padding: "6px" }}>Address</th>
        <th style={{ border: "1px solid #ccc", padding: "6px" }}>Lat</th>
        <th style={{ border: "1px solid #ccc", padding: "6px" }}>Lng</th>
        <th style={{ border: "1px solid #ccc", padding: "6px" }}>Note</th>
        <th style={{ border: "1px solid #ccc", padding: "6px" }}>Link</th>
        <th style={{ border: "1px solid #ccc", padding: "6px" }}>Edit</th>
      </tr>
    </thead>
    <tbody>
      {locations.map((loc) => (
        <tr key={loc.id || loc.location_id}>
          <td style={{ border: "1px solid #eee", padding: "5px" }}>{loc.code}</td>
          <td style={{ border: "1px solid #eee", padding: "5px" }}>{loc.interaction_count || 0}</td>
          <td style={{ border: "1px solid #eee", padding: "5px" }}>{loc.campaign_name}</td>
          <td style={{ border: "1px solid #eee", padding: "5px" }}>{loc.address}</td>
          <td style={{ border: "1px solid #eee", padding: "5px" }}>{loc.latitude}</td>
          <td style={{ border: "1px solid #eee", padding: "5px" }}>{loc.longitude}</td>
          <td style={{ border: "1px solid #eee", padding: "5px" }}>{loc.note}</td>
          <td style={{ border: "1px solid #eee", padding: "5px" }}>
            <a href={loc.landing_url} target="_blank" rel="noopener noreferrer">
              Open
            </a>
          </td>
          <td style={{ border: "1px solid #eee", padding: "5px" }}>
            <button
              onClick={() => handleEdit(loc)}
              style={{ padding: "4px 8px", fontSize: "14px", cursor: "pointer" }}
            >
              Edit
            </button>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>
    </>
) : (
  <div>Loading map...</div>
);
  
};

export default QrLocationForm;